<div class="locationRibbon"
     *ngIf="this.routeArray !== [] && this.routeArray.length > 1">
  <div *ngFor="let m of routeArray; let i = index">
    <div class="routes">
      <h3>
        <a [class.current]="routeArray.length - 1 === i"
           [routerLink]="m.route ? ['/' + m.route.toLowerCase()] : null">
          {{ m.translated }}
        </a>
      </h3>
      <h3 *ngIf="routeArray.length - 1 !== i">/</h3>
    </div>
  </div>

  <div class="wiki">
    <app-wiki [menid]="menid"></app-wiki>
  </div>
</div>
